import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { CursoPageComponent } from './pages/cursos/curso-page/curso-page.component';
import { SobrePageComponent } from './pages/sobre/sobre-page/sobre-page.component';
import { SedePageComponent } from './pages/sede/sede-page/sede-page.component';
import { PoloPageComponent } from './pages/polo/polo-page/polo-page.component';
import { InfraestruturaPageComponent } from './pages/infraestrutura/infraestrutura-page/infraestrutura-page.component';
import { CorpoDocentePageComponent } from './pages/corpo-docente/corpo-docente-page/corpo-docente-page.component';
import { FacintGoianiaPageComponent } from './pages/facint-goiania/facint-goiania-page/facint-goiania-page.component';
import { FacintecPageComponent } from './pages/facintec/facintec-page/facintec-page.component';
import { EjaPageComponent } from './pages/eja/eja-page/eja-page.component';
import { AtenaIdiomasPageComponent } from './pages/atena-idiomas/atena-idiomas-page/atena-idiomas-page.component';
import { CursoGraduacaoListComponent } from './pages/cursos/curso-graduacao-list/curso-graduacao-list.component';
import { CursoPosGraduacaoListComponent } from './pages/cursos/curso-pos-graduacao-list/curso-pos-graduacao-list.component';

const routes: Routes = [
  { path: '', loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule) },
  { path: 'cursos-graduacao', component: CursoGraduacaoListComponent },
  { path: 'cursos-pos-graduacao', component: CursoPosGraduacaoListComponent },
  { path: 'cursos/:slug', component: CursoPageComponent },
  { path: 'a-facint', component: SobrePageComponent },
  { path: 'sede', component: SedePageComponent },
  { path: 'polos', component: PoloPageComponent },
  { path: 'infraestrutura', component: InfraestruturaPageComponent },
  { path: 'corpo-docente', component: CorpoDocentePageComponent },
  { path: 'facint-goiania', component: FacintGoianiaPageComponent },
  { path: 'facintec', component: FacintecPageComponent },
  { path: 'eja', component: EjaPageComponent },
  { path: 'atena-idiomas', component: AtenaIdiomasPageComponent }
];

const routerOptions: ExtraOptions = {
  scrollPositionRestoration: 'enabled',
  anchorScrolling: 'enabled',
  scrollOffset: [0, 0],
  initialNavigation: 'enabledBlocking',
};

@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
